import { formDataDefault } from '@/components/dash/postCreator/constante.js'
import { getInfoFile, getErrorNetworkFile } from '@/components/dash/postCreator/utils.js'
import { foreachSaveAllFormData } from '../../postCreator/utils'
const [STORY_HEIGHT, STORY_WIDTH] = [640, 360]


export async function convertOldDraft(draft, pagesId) {
    if (draft.saveAllFormData) return


    if (pagesId && pagesId.length) {
        draft.pages = pagesId
    }
   
    draft.saveAllFormData = {
        main: JSON.parse(JSON.stringify(formDataDefault)),
        networks: {},
        pages: {},
    }
    
    draft.files = {}

    const time = Date.now()
    const formDataMain = draft.saveAllFormData.main
    const files = draft.files
    //function
    function replaceMentions(text) {
        return text.replace(/@\[\MENTIONS-(\d+)\]/g, (match, x) => `@${time + Number(x)}`);
    }

    function replaceHashtags(text) {
        console.log("replaceHashtags",text)
        return text.replace(/#\[\HASHTAGS-(\d+)\]/g, (match, x) => {
            try {
                return `#${draft.hashtagsAdded[Number(x)-1][0]["0"].hashtag}`;
            } catch (error) {
                return `#[HASHTAGS-${x}]`;
            }
        })
    }
    
    async function addFile(url, fileName) {
        
        let idFile = Math.random().toString(36).substr(2, 9);
        const file = await downloadFile(url, fileName)
        const blobUrl = URL.createObjectURL(file); //evite error CORS pour getInfoFile()
        
        const info = await getInfoFile(file, blobUrl);
        const errorNetwork = getErrorNetworkFile({info});

        const fileData = {
            id: idFile,
            url,
            info,
            errorNetwork: errorNetwork,
            isUpload: true,
            failedUpload: false,
            uploadProgress: false,
            percentUpload: 100
        };

        files[idFile] = fileData
        return fileData
    }

    //tab
    if (draft.typePost && draft.typePost == "story") {
        draft.tab = "story"
    }

    //date
    if (draft.scheduling && draft.scheduling.show) {
        //formDataMain.planifiedDate
        const dateInstance = new Date(draft.scheduling.lastScheduled || draft.scheduling.date)
        formDataMain.planifiedDate = {
            date: dateInstance.toISOString().split('T')[0],
            hours: `${draft.scheduling.time['HH']}:${draft.scheduling.time['mm']}`,
            timestamp: dateInstance.getTime()
        }
    }


    draft.idUsersAssigned = []
    draft.requiredValidation = false
    //affectedTo / assignation
    if (draft.affectedTo) {

        if (draft.affectedTo.users && draft.affectedTo.users.length) {
            draft.idUsersAssigned = draft.affectedTo.users.map(user => user.id)
        }

        if (draft.affectedTo.user && !draft.idUsersAssigned.includes(draft.affectedTo.user.id)) {
            draft.idUsersAssigned.push(draft.affectedTo.user.id)
        }

        if (draft.affectedTo.optionValidation) {
            draft.requiredValidation = true
        }
        
    }

    //mentions
    if (draft.mentionsAdded && draft.mentionsAdded.length) {
        let objMention;
        formDataMain.mentions = draft.mentionsAdded.reduce((acc, arrayMentionByNetwork, index) => {
            objMention = {
                mention: {},
                textDefault: "Text default"
            }

            objMention.mention = arrayMentionByNetwork.reduce((acc2, mention) => {
                acc2[mention.network] = {
                    ...mention
                }
                return acc2
            },{})

            acc[time+index+1] = objMention
            return acc
        },{})
    }

    //textContent
    if (draft.form.title) {
        formDataMain.textContent = replaceHashtags(replaceMentions(draft.form.title + (draft.form.description ? `<br>${draft.form.description}` : '')))
    }

    //textComment
    if (draft.form.comments && draft.form.comments.length) {
        formDataMain.comments = draft.form.comments.map((comment)=> replaceHashtags(replaceMentions(comment)))
    }

    //url
    if (draft.form.url) {
        ['facebook', 'google', 'linkedin', 'threads', 'twitter', 'pinterest'].forEach(networkName => {
            formDataMain.formDataNetwork[networkName].snippet.link = draft.form.url
        });
    }

    //snippet custom
    if (draft.snippetTitle) {
        ['facebook','linkedin'].forEach(networkName => {
            formDataMain.formDataNetwork[networkName].snippet.title = draft.snippetTitle
        });
    }
    if (draft.snippet) {
        ['facebook','linkedin'].forEach(networkName => {
            formDataMain.formDataNetwork[networkName].snippet.imageUrl = draft.snippet
        });
    }

    //share story
    if (draft.shareAfterPost) {
        formDataMain.formDataNetwork['instagram'].storification.active = true

        //share story to facebook 
        if (draft.storyShareToFacebook) {
            formDataMain.formDataNetwork['instagram'].storification.shareInFacebook = true
        }
    }

    //location
    if (draft.location) {
        const locationByNetwork = JSON.parse(draft.location)
        for (const [networkName, location] of Object.entries(locationByNetwork)) {
            formDataMain.formDataNetwork[networkName].place = location
        }
    }

    //media
    if (draft.multipleMedias.length) {
        formDataMain.files = await Promise.all(
            draft.multipleMedias.map(async (media) => {
                const fileData = await addFile(media.url, media.name);
                return {id: fileData.id};
            })
        );
    }else if (draft.multipleImages.length) {
        console.log('convertOldDraft', 1)
        formDataMain.files = await Promise.all(
            draft.multipleImages.map(async (media) => {
                console.log('convertOldDraft', 2)
                const fileData = await addFile(media.url, media.name);
                console.log('convertOldDraft',3)
                return {id: fileData.id};
            })
        );
        console.log('convertOldDraft',4)
 
    }

    const videos = JSON.parse(draft.videos)
    for (const [key, url] of Object.entries(videos)) {
        let networkName = key.split('_')[0]
        if (url) {

            const fileData = await addFile(url, draft.videoname);
            if (!draft.saveAllFormData.networks[networkName]) draft.saveAllFormData.networks[networkName] = {}
            draft.saveAllFormData.networks[networkName].files = [{
                id: fileData.id
            }]

            const networkSetting = {
                facebook : 'typeMedia',
                linkedin: 'typeMedia',
                twitter: 'typeContent',
            }
            if (networkSetting[networkName]) {

                formDataMain.formDataNetwork[networkName][networkSetting[networkName]] = 'video'
            }
        }
    }

    //sondage linkedin
    if (draft.poll && draft.poll.question) {
        formDataMain.formDataNetwork['linkedin'].survey = {
            active : true,
            duration: {'86400': 'oneDay', '259200': 'threeDay', '604800': 'oneWeek', '1209600': 'twoWeek' }[String(draft.poll.duration)],
            question : draft.poll.question,
            options : draft.poll.options
        }

    //document linkedin
    }else if (draft.typePost == 'document' && draft.form.enclosure) {
        const fileData = await addFile(draft.form.enclosure, draft.form.documentTitle)
        formDataMain.files = [{
            id: fileData.id
        }, ...formDataMain.files]

        formDataMain.formDataNetwork['linkedin'].pdf = {
            title: draft.form.documentTitle || ''
        }
        formDataMain.formDataNetwork['linkedin'].typeMedia = 'pdf'
       
    }
    
    //mention instagram

    if (draft.userTags) {
        let userTags = JSON.parse(draft.userTags)

        if (userTags.list && userTags.list.length) {

            if (userTags.collab && userTags.collab.length) {
                formDataMain.formDataNetwork['instagram'].collaborators = userTags.collab.map((id) => {
                    let mention;
                    userTags.list = userTags.list.filter(m => {
                        if (m.id == id){
                            mention = m
                            return false
                        }
                        return true
                    })
    
                    if (mention) {
                        return {
                            id: mention.username,
                            idFile: null,
                            image: null,
                            name: mention.name,
                            pk: mention.id,
                            timestamp: time + mention.index,
                            x: Number(mention.x) * 100,
                            y: Number(mention.y) * 100,
                        }
                    }
                    return null
                })
            }

            formDataMain.formDataNetwork['instagram'].personsIdentified = userTags.list.map((mention) => ({
                id: mention.username,
                idFile: null,
                image: null,
                name: mention.name,
                pk: mention.id,
                timestamp: time + mention.index,
                x: Number(mention.x) * 100,
                y: Number(mention.y) * 100,
            }))
        }
    }

    //music instagram
    if (draft.musicStory && draft.musicStory.track && draft.musicStory.metadata) {
        formDataMain.formDataNetwork['instagram'].music = {
            metadata: draft.musicStory.metadata,
            track: draft.musicStory.track,
        }
    }
    //tiktok
    if (draft.tiktokOptions) {
        const tiktokOptions = JSON.parse(draft.tiktokOptions)
        formDataMain.formDataNetwork['tiktok'] = {
            visibility: {
                PUBLIC_TO_EVERYONE: 'all',
                MUTUAL_FOLLOW_FRIENDS: 'friends',
                SELF_ONLY: 'me',
            }[tiktokOptions.privacy_level],
            commentDisable: tiktokOptions.comment_disabled,
            useVideoForDuo: !tiktokOptions.duet_disabled,
            useVideoForOtherVideo: !tiktokOptions.stitch_disabled
        }
    }

    //pinterest
    if (draft.form.boardSelected) {
        formDataMain.formDataNetwork['pinterest'].boardSelectedByPage = {
            ['????'] : draft.form.boardSelected
        }
    }

    //youtube
    if (draft.youtubeOptions) {
        const youtubeOptions = JSON.parse(draft.youtubeOptions)
        formDataMain.formDataNetwork['youtube'] = {
            visibility : {
                public: "all",
                private: "private",
                unlisted: "unlisted"
            }[youtubeOptions.privacy_level],
            category : youtubeOptions.category,
            notifySubscribers: youtubeOptions.notifySubscribers,
            contentForChildren: youtubeOptions.madeForKids,
            tags : youtubeOptions.tags && youtubeOptions.tags.length ? youtubeOptions.tags.map(tag => tag.text) : [],
            playlistSelectedByPage : youtubeOptions.playlist ? {
                ['????'] : youtubeOptions.playlist
            } : null
        }
    }

    console.log('convertOldDraft', draft)

    let stories;
    
    if (draft.storyMultiple.length == 1) {
        stories = [{
            storificationData: draft.storificationData,
            url: draft.form.url,
            enclosure: draft.form.enclosure
        }]
    }else{
        stories =  draft.storyMultiple.map(({story})=> (story))
    }
    formDataMain.storification = {}

    let idStory = String(time)
    let indexStory = -1
    for (const {storificationData:story, url:urlStory, enclosure: enclosureStory} of stories) {
        indexStory++
        idStory = String(Number(idStory) + 1)

        formDataMain.storification[idStory] = {}

        //background
        formDataMain.storification[idStory].background = {
            // file : {
            //     id: 1234567890,
            //     type:'image/jpeg',
            //     name:'imageDefault',
            //     size: 0,
            //     url : 'https://i.pinimg.com/236x/84/bd/bc/84bdbc1507a0697fe9288477342b2005.jpg', //temporaire
            // },
            file: null,
        
            color : story.backgroundColor || "#000000",
            size : 'containY', // 'cover' | 'containX' | 'containY'
            position: {"x":50,"y":50},
            transform: {"rotate":0,"scale":1}
        }

        if (enclosureStory) {
            const fileEnclosure = await addFile(enclosureStory);
            formDataMain.storification[idStory].background.file = {
                id: fileEnclosure.id
            }
        }

        //sticker 

        formDataMain.storification[idStory].stickers = {}
        
        let lastIdSticker = String(time)

        //gif
        if (story.gifs && story.gifs.length) {
            story.gifs.forEach((gif, index) => {
                lastIdSticker = String(Number(lastIdSticker) + 1)

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'gif',
                    isEditing: false,
                    position : {
                        x: (gif.x + gif.w / 2) / STORY_WIDTH * 100, 
                        y: (gif.y + gif.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: gif.angle,
                        scale: gif.scale - 0.2
                    },
                    
                    data : {
                        gif: gif,
                    },
                }
            }); 
        }

        //hashtags
        if (story.hashtags && story.hashtags.length) {
            story.hashtags.forEach((hashtag, index) => {
                lastIdSticker = String(Number(lastIdSticker) + 1)

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'hashtag',
                    isEditing: false,
                    position : {
                        x: (hashtag.x + hashtag.w / 2) / STORY_WIDTH * 100, 
                        y: (hashtag.y + hashtag.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: hashtag.angle,
                        scale: hashtag.scale
                    },
                    
                    data : {
                        hashtag : hashtag.hashtag,
                        styleVariant: hashtag.color
                    },
                }
            }); 
        }

        //location
        if (story.location) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'location',
                isEditing: false,
                position : {
                    x: (story.location.x + story.location.w / 2) / STORY_WIDTH * 100, 
                    y: (story.location.y + story.location.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.location.angle,
                    scale: story.location.scale
                },
                
                data : {
                    place : {...story.location.location, name: story.location.name},
                    styleVariant: story.location.color
                }
            }
        }

        //mention
        if (story.mentions && story.mentions.length) {
            story.mentions.forEach((mention, index) => {
                lastIdSticker = String(Number(lastIdSticker) + 1)

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'mention',
                    isEditing: false,
                    position : {
                        x: (mention.x + mention.w / 2) / STORY_WIDTH * 100, 
                        y: (mention.y + mention.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: mention.angle,
                        scale: mention.scale
                    },
                    
                    data : {
                        mention : {
                            id: mention.id,
                            pk: mention.pk || null
                        },
                        styleVariant: mention.color
                    },
                }
            }); 
        }

        //music
        if (story.music) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'music',
                isEditing: false,
                position : {
                    x: 50,
                    y: 50
                },
                
                transform: {
                    rotate: 0,
                    scale: 1
                },
                
                data : {
                    music: story.music,
                },
            }
        }

        //survey
        if (story.poll) {
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'survey',
                isEditing: false,
                position : {
                    x: (story.poll.x + story.poll.w / 2) / STORY_WIDTH * 100, 
                    y: (story.poll.y + story.poll.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.poll.angle,
                    scale: story.poll.scale - 0.2
                },
                
                data : {
                    question : story.poll.question,
                    responses : story.poll.options,
                    color : '#0C0F14',
                },
            }
        }

        //product
        if (story.product) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'product',
                isEditing: false,
                position : {
                    x: (story.product.x + story.product.w / 2) / STORY_WIDTH * 100, 
                    y: (story.product.y + story.product.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.product.angle,
                    scale: story.product.scale
                },
                
                data : {
                    products : story.product.items.map(item => ({
                        ...item, 
                        shopId: item.merchantId,
                        description: '',
                        image: null
                    })),
                    font: 'classic-font',
                    color: '#4396F6',
                    styleVariant: 1
                },
            }
        }

        //question
        if (story.question) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'question',
                isEditing: false,
                position : {
                    x: (story.question.x + story.question.w / 2) / STORY_WIDTH * 100, 
                    y: (story.question.y + story.question.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.question.angle,
                    scale: story.question.scale -0.2
                },
                
                data : {
                    question: story.question.text,
                    color: '#FFFFFF',
                },
            }
        }

        //slider
        if (story.slider) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'slider',
                isEditing: false,
                position : {
                    x: (story.slider.x + story.slider.w / 2) / STORY_WIDTH * 100, 
                    y: (story.slider.y + story.slider.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.slider.angle,
                    scale: story.slider.scale
                },
                
                data : {
                    question : story.slider.question,
                    emoji: story.slider.emoji,
                    color: '#FFFFFF',
                },
            }
        }

        //texts
        if (story.texts && story.texts.length) {
            story.texts.forEach((text, index) => {
                lastIdSticker = String(Number(lastIdSticker) + 1)

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'text',
                    isEditing: false,
                    position : {
                        x: (text.x + text.w / 2) / STORY_WIDTH * 100, 
                        y: (text.y + text.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: text.angle,
                        scale: text.scale
                    },

                    data : {
                        text: text.content,
                        mentions: {},
                        font: ["modern-font", "classic-font","signature-font", "editor-font", "poster-font", "bubble-font", "deco-font", "squeeze-font", "typewriter-font", "strong-font", "meme-font", "elegant-font", "directional-font", "literature-font"][text.font],
                        align: 'center',
                        color: text.color,
                        fontSize: parseFloat(text.size),//27.5
                        background : ["none", "secondary", "primary"][text.background],
                    },
                }
            }); 
        }

        //images
        if (story.layers && story.layers.length) {

            for (const layer of story.layers) {

                lastIdSticker = String(Number(lastIdSticker) + 1)
                const fileData = await addFile(layer.url);

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'image',
                    isEditing: false,
                    position : {
                        x: (layer.x + layer.w / 2) / STORY_WIDTH * 100, 
                        y: (layer.y + layer.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: layer.angle,
                        scale: layer.scale - 0.2
                    },

                    data : {
                        idFile: fileData.id,
                    },
                }
            }; 
        }
        //link
        if (story.link) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'link',
                isEditing: false,
                position : {
                    x: (story.link.x + story.link.w / 2) / STORY_WIDTH * 100, 
                    y: (story.link.y + story.link.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.link.angle,
                    scale: story.link.scale
                },
                
                data : {
                    link : urlStory,
                    text: story.link.text || '',
                    styleVariant: 1
                },
            }
        }
        
        //highlight
        if (story.hightlight) {
            formDataMain.storification[idStory].highlight = {
                id:story.hightlight,
                text:null,
                img:null,
            }
        }
        //musicReel ?? template ?? textsReel ?? 
    };

    //customization
    if (draft.editPostValue && draft.editPostValue.length) {
        draft.editPostValue.forEach(edit => {
            draft.saveAllFormData.pages[edit.page] = {}

            //textContent
            if (edit.title){
                draft.saveAllFormData.pages[edit.page].textContent = replaceHashtags(replaceMentions(edit.title + (draft.form.description ? `<br>${draft.form.description}` : '')))
            }


            //date
            if (edit.scheduling){
                const dateInstance = new Date(edit.scheduling.date)
                formDataMain.planifiedDate = {
                    date: dateInstance.toISOString().split('T')[0],
                    hours: `${edit.scheduling.time['HH']}:${draft.scheduling.time['mm']}`,
                    timestamp: dateInstance.getTime()
                }
            }

            //comment
        });
    }

    return draft
}
export async function convertNewsToDraft(news, needConstructDraft=false) {

    async function addFile(url, type='image') {
        let fileData = null

        if(type == 'image') {

            let uploadUrl = await fetch(`${process.env.VUE_APP_VIDEO_API_HOST}/image/save/media?url=${encodeURIComponent(url)}`)
            uploadUrl = await uploadUrl.json()
            console.log('uploadUrl', uploadUrl)
    
            if(uploadUrl?.url) {
                let idFile = Math.random().toString(36).substr(2, 9);
                let info = {
                    "name": uploadUrl.url.split('/').pop(),
                    "size": uploadUrl.infos.size,
                    "type": `image/${uploadUrl.infos.format}`,
                    "type2": "image",
                    "width": uploadUrl.infos.width,
                    "height": uploadUrl.infos.height,
                    "aspectRatio": uploadUrl.infos.aspectRatio,
                    "averageColor": uploadUrl.infos.averageColor,
                    "enclosure": uploadUrl.url
                }
                const errorNetwork = getErrorNetworkFile({info});
                fileData = {
                    id: idFile,
                    url: uploadUrl.url,
                    info,
                    errorNetwork: errorNetwork,
                    isUpload: true,
                    failedUpload: false,
                    uploadProgress: false,
                    percentUpload: 100
                };
            }
        }
        else if(type == 'video') {
            let infoVideo = await fetch(`${process.env.VUE_APP_VIDEO_API_HOST}/v2/video/infos?url=${encodeURIComponent(url)}`)
            infoVideo = await infoVideo.json()
            console.log('infoVideo', infoVideo)

            if(infoVideo?.informations) {
                let idFile = Math.random().toString(36).substr(2, 9);
                let info = {
                    "name": url.split('/').pop(),
                    "size": infoVideo.informations.format.size,
                    "type": `video/${url.split('.').pop()}`,
                    "type2": "video",
                    "width": infoVideo.informations.streams.find(s => s.codec_type == 'video').width,
                    "height": infoVideo.informations.streams.find(s => s.codec_type == 'video').height,
                    "aspectRatio": infoVideo.informations.streams.find(s => s.codec_type == 'video').width/infoVideo.informations.streams.find(s => s.codec_type == 'video').height,
                    "averageColor": "#000000",
                    "enclosure": null,
                    "duration": infoVideo.informations.format.duration
                }
                const errorNetwork = getErrorNetworkFile({info});
                fileData = {
                    id: idFile,
                    url: url,
                    info,
                    errorNetwork: errorNetwork,
                    normalizedNetworks: {},
                    isUpload: true,
                    failedUpload: false,
                    uploadProgress: false,
                    percentUpload: 100,
                    isNormalizing: false
                };
            }
        }
        else if(type == 'pdf') {
            let idFile = Math.random().toString(36).substr(2, 9);
            let info = {
                "name": url.split('/').pop(),
                "customName": news.page[0].document_title,
                "size": null,
                "type": "application/pdf",
                "type2": "pdf",
                "width": null,
                "height": null,
                "aspectRatio": null,
                "averageColor": null,
                "enclosure": null
            }
            fileData = {
                id: idFile,
                url: url,
                info,
                errorNetwork: {},
                normalizedNetworks: {},
                isUpload: true,
                failedUpload: false,
                uploadProgress: false,
                percentUpload: 100,
                isNormalizing: false
            };
        }

        
        return fileData
    }

    const draft = {
        saveAllFormData : {
            main: JSON.parse(JSON.stringify(formDataDefault)),
            networks: {},
            pages: {},
        }
    }

    console.log('news convert', news)

    let bot = news._bots[0]

    let currentDate = new Date(Date.now() + 600000) //date actuelle + 10 minutes
    let hours = currentDate.getHours()
    let minutes = currentDate.getMinutes()
    let date = currentDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-');

    draft.saveAllFormData.main.textContent = news.title

    if(!news.page || !news.page.length || !news.page[0].isManualPost) {
        draft.saveAllFormData.main.textContent = bot.post_text_layout == 'title' 
                                                        ? news.title
                                                        : (bot.post_text_layout == 'description' ? news.description : '')
        if(bot.mode == 'image') {
            if(bot.positionlink?.includes('in_posts'))
                draft.saveAllFormData.main.textContent += ' ' + news.url
            else if(bot.positionlink?.includes('on_top_posts'))
                draft.saveAllFormData.main.textContent = news.url + ' \n' + draft.saveAllFormData.main.textContent
    
            if(bot.positionlink?.includes('in_comments'))
                draft.saveAllFormData.main.comments = [news.url]

            if(!bot.positionlink){
                if(bot.linkInComments)
                    draft.saveAllFormData.main.comments = [news.url]
                else 
                    draft.saveAllFormData.main.textContent += ' ' + news.url
            }
        }
        else if(bot.mode == 'standard' && news.url && draft.saveAllFormData.main.formDataNetwork[bot.type]?.snippet) {        
            // TODO : à revoir avec clément pour activer le snippet par defaut dans le formulaire (page fb dalon post en attente)
            draft.saveAllFormData.main.formDataNetwork[bot.type].snippet.link = news.url
            draft.saveAllFormData.main.urlsTextContent = [news.url]
            draft.saveAllFormData.main.urlsTextContentHistory = [news.url]
        }
    
        if(bot.hashtagPrefix)
            draft.saveAllFormData.main.textContent = bot.hashtagPrefix + ' ' + draft.saveAllFormData.main.textContent
        if(bot.hashtag)
            draft.saveAllFormData.main.textContent += ' ' + bot.hashtag
    }


    draft.saveAllFormData.main.planifiedDate = {
        "date": date,
        "hours": `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
        "timestamp": currentDate.getTime()
    }

    draft.saveAllFormData.main.files = []
    draft.files = {}
    if(needConstructDraft) {
        if((!news.page || !news.page.length) && news.medias?.length){
            for(let m of news.medias) {
                const fileData = await addFile(m.url, m.type);
                if(fileData) {
                    draft.saveAllFormData.main.files.push({id: fileData.id})
                    draft.files[fileData.id] = fileData
                }
            }
            if(news.medias[0].type == 'video') {
                draft.saveAllFormData.main.formDataNetwork.facebook.typeMedia = 'video'
                draft.saveAllFormData.main.formDataNetwork.linkedin.typeMedia = 'video'
                draft.saveAllFormData.main.formDataNetwork.twitter.typeContent = 'video'
            }
        }
        else if(news.page?.length && news.page[0].typePost == 'standard' && news.url && draft.saveAllFormData.main.formDataNetwork[bot.type]?.snippet) {        
            // TODO : à revoir avec clément pour activer le snippet par defaut dans le formulaire (page fb dalon post en attente)
            draft.saveAllFormData.main.formDataNetwork[bot.type].snippet.link = news.url
            draft.saveAllFormData.main.urlsTextContent = [news.url]
            draft.saveAllFormData.main.urlsTextContentHistory = [news.url]
        }
        else if(news.page?.length && news.page[0].network == 'linkedin' && news.page[0].typePost == 'document' && news.page[0].enclosure.endsWith('.pdf')) {
            // TODO à voir avec clément : le pdf est bien présent dans le form mais ne s'affiche pas sur le drawerpost (post 01/07/25 sur linkedin mwtest)
            const fileData = await addFile(news.page[0].enclosure, 'pdf');
            if(fileData) {
                draft.saveAllFormData.main.files = [
                    {id: fileData.id}
                ]
                draft.files[fileData.id] = fileData
                draft.saveAllFormData.main.formDataNetwork.linkedin.typeMedia = 'pdf'
            }

          
        }
        else if(news.page?.length && news.page[0].network == 'linkedin' && news.page[0].typePost == 'poll' && news.page[0].poll) {
            let poll = JSON.parse(news.page[0].poll)
            let durations = {'86400': 'oneDay', '259200': 'threeDay', '604800': 'oneWeek', '1209600': 'twoWeek' }            
            draft.saveAllFormData.main.formDataNetwork.linkedin.survey = {
                "active": true,
                "duration": durations[poll.duration.toString()],
                "question": poll.question,
                "options": poll.options
            }
        }
        else if(news.page?.length && news.page[0].typePost == 'video' && news.page[0].video) {
            const fileData = await addFile(news.page[0].video, 'video');
            if(fileData) {
                draft.saveAllFormData.main.files.push({id: fileData.id})
                draft.files[fileData.id] = fileData
            }
            draft.saveAllFormData.main.formDataNetwork.facebook.typeMedia = 'video'
            draft.saveAllFormData.main.formDataNetwork.linkedin.typeMedia = 'video'
            draft.saveAllFormData.main.formDataNetwork.twitter.typeContent = 'video'
        }
        else if(news.page?.length && news.page[0].carousel && news.page[0].carousel.length) {
            for(let m of news.page[0].carousel) {
                const fileData = await addFile(m.url);
                if(fileData) {
                    draft.saveAllFormData.main.files.push({id: fileData.id})
                    draft.files[fileData.id] = fileData
                }
            }
        }
        else if(news.page?.length && news.page[0].multipleMedias?.length) {
            for(let m of news.page[0].multipleMedias) {
                const fileData = await addFile(m.url, m.type.includes('image') ? 'image' : 'video');
                if(fileData) {
                    draft.saveAllFormData.main.files.push({id: fileData.id})
                    draft.files[fileData.id] = fileData
                }
            }
            if(news.page[0].multipleMedias[0].type.includes('video')) {
                draft.saveAllFormData.main.formDataNetwork.facebook.typeMedia = 'video'
                draft.saveAllFormData.main.formDataNetwork.linkedin.typeMedia = 'video'
                draft.saveAllFormData.main.formDataNetwork.twitter.typeContent = 'video'
            }
        }

        else if((news.page?.length && news.page[0].enclosure) || news.enclosure) {

            const fileData = await addFile(news.page && news.page.length && news.page[0].enclosure ? news.page[0].enclosure : news.enclosure);
            if(fileData) {
                draft.saveAllFormData.main.files = [
                    {id: fileData.id}
                ]
                draft.files[fileData.id] = fileData
            }
        }

        // TODO : à revoir avec clément pour positionnement des stickers (post en attente sur page insta johnsmitch)
        if(!news.page || !news.page.length || !news.page[0].isManualPost) {
            if(bot.mode == 'story' && draft.saveAllFormData.main.files.length) {

                const getPositionInPourcent = (x, y) => {
                    const widthMax = 1080;
                    const heightMax = 1920;
                    const pourcentX = (x / widthMax) * 100;
                    const pourcentY = (y / heightMax) * 100;
                    return {
                        x: parseFloat(pourcentX.toFixed(2)),
                        y: parseFloat(pourcentY.toFixed(2))
                    }
                }

                const getCenterPositionWithScaleInPourcent = (left, top, elementW, elementH, scale = 1) => {
                    const widthMax = 1080;
                    const heightMax = 1920;
                    const scaledW = elementW * scale;
                    const scaledH = elementH * scale;
                    const centerX = left + (scaledW / 2);
                    const centerY = top + (scaledH / 2);
                    const pourcentX = (centerX / widthMax) * 100;
                    const pourcentY = (centerY / heightMax) * 100;
                    return {
                        x: parseFloat(pourcentX.toFixed(2)),
                        y: parseFloat(pourcentY.toFixed(2))
                    };
                }

                const calculateScale = (w_original, h_original, w_target, h_target) => {
                    console.log('calculateScale', w_original, h_original, w_target, h_target)
                    // Calcul individuel
                    const scaleX = w_target / w_original;
                    const scaleY = h_target / h_original;
                    return {
                        scaleX: parseFloat(scaleX.toFixed(4)), // Rapport largeur
                        scaleY: parseFloat(scaleY.toFixed(4)), // Rapport hauteur
                        // Souvent utilisé pour le redimensionnement proportionnel (type "contain")
                        scaleMin: Math.min(scaleX, scaleY), 
                        // Souvent utilisé pour le redimensionnement proportionnel (type "cover")
                        scaleMax: Math.max(scaleX, scaleY)
                    };
                }
                
                draft.tab = 'story'
                draft.saveAllFormData.main.storification = {}
                draft.saveAllFormData.main.storification[0] = {
                    "hide":false,
                    "background": {
                        "file": draft.saveAllFormData.main.files[0],
                        "color":"#000000",
                        "size":"containX",
                        // "position":{"x":50,"y":50},
                        "position": getCenterPositionWithScaleInPourcent(bot.storyTemplate.configuration.image.x, bot.storyTemplate.configuration.image.y, draft.files[draft.saveAllFormData.main.files[0].id].info.width, draft.files[draft.saveAllFormData.main.files[0].id].info.height, calculateScale(draft.files[draft.saveAllFormData.main.files[0].id].info.width, draft.files[draft.saveAllFormData.main.files[0].id].info.height, bot.storyTemplate.configuration.image.w, bot.storyTemplate.configuration.image.h).scaleMax),
                        "transform":{
                            "rotate":0,
                            // "scale":1
                            scale: calculateScale(draft.files[draft.saveAllFormData.main.files[0].id].info.width, draft.files[draft.saveAllFormData.main.files[0].id].info.height, bot.storyTemplate.configuration.image.w, bot.storyTemplate.configuration.image.h).scaleMax
                        }
                    },
                    "stickers":{
                        // "1111111111112":{
                        //     "type":"image",
                        //     "isEditing":false,
                        //     "position":{"x":68.58813979338507,"y":78.2314492152546},
                        //     "transform":{"rotate":0,"scale":0.6713082992384297},
                        //     "data":{"idFile":"83z3ojo15"},
                        //     "id":1111111111112,
                        //     "zIndex":12
                        // },
                        "1111111111113": {
                            "type":"text",
                            "isEditing":false,
                            // "position":{"x":48.8386441170066,"y":84.7542054548424},
                            "position": getPositionInPourcent(bot.storyTemplate.configuration.text.x, bot.storyTemplate.configuration.text.y),
                            "transform":{"rotate":0,"scale":1},
                            "data":{
                                "text": draft.saveAllFormData.main.textContent,
                                "mentions":{},
                                "font":"modern-font",
                                // "align":"center",
                                "align": bot.storyTemplate.configuration.text.align,
                                // "color":"#fff",
                                "color": bot.storyTemplate.configuration.text.color,
                                "fontSize":27.5,
                                "background":"secondary"
                            },
                            "id":1111111111113,
                            "zIndex":12
                        }
                    },
                    "highlight":{"id":null,"text":null},
                    "shareInFacebook":false
                }

                // formData.storification[0].stickers = {}
            }
        }
        if(news.page?.length && news.page[0].isManualPost && news.page[0].comments?.data?.length) {
            draft.saveAllFormData.main.comments = news.page[0].comments.data
        }
    }

    console.log('convert draft standard', draft)

    // old draft (v1)
    draft.form = {
        "page": 0,
        "name": null,
        "url": null,
        "file": null,
        "date": null,
        "time": null,
        "title": draft.saveAllFormData.main.textContent,
        "enclosure": news.enclosure
    }
    draft.scheduling = {
        "lastScheduled": currentDate.toISOString,
        "show": true,
        "date": currentDate.toISOString,
        "time": {
            "HH": `${hours}`,
            "mm": `${minutes}`
        }
    }
    draft.pages = [bot.page.id]
    draft.bot = [bot.id],
    draft.editPostValue = [] 

    return draft

}

export async function convertDirectPostToNews(page, p) {

    let post
    switch(page.network) {
        case 'instagram' :
            post = {
            title: p.caption,
            description: p.caption,
            created_at: p.created_time,
            published_at: p.created_time,
            // "url": "",
            "enclosure": p.media_url,
            "page": [
                {  
                "isManualPost": true,
                "id": page.bots[0].id,
                "post_number": p.id,
                "posted_date": p.created_time,
                "network": page.network,
                "status": 2,
                "video": p.media_type == 'VIDEO' ? p.media_url : null,
                "enclosure": p.media_type == 'IMAGE' ? p.media_url : null,
                "carousel": p.media_type == 'CAROUSEL_ALBUM' ? p.medias : null,
                "link": p.permalink,
                "comment_count": p.comment_count
                }
            ],
            "_id": `network_post_id-${p.id}`,
            "id": `network_post_id-${p.id}`,
            "_bots": [page.bots[0]],
            "status": "posted"
            }
            break
        case 'facebook':
            post = {
            title: p.message,
            description: p.message,
            created_at: p.created_time,
            published_at: p.created_time,
            "url": p.link ? p.link : null,
            "enclosure": p.full_picture,
            "page": [
                {  
                "isManualPost": true,
                "id": page.bots[0].id,
                "post_number": p.id,
                "posted_date": p.created_time,
                "network": page.network,
                "status": 2,
                "video": p.attachments && p.attachments.data && p.attachments.data.length && p.attachments.data[0].type == 'video_inline' ? p.video : null,
                "enclosure": p.attachments && p.attachments.data && p.attachments.data.length && p.attachments.data[0].type == 'photo' ? p.attachments.data[0].media.image.src : null,
                "carousel": p.attachments && p.attachments.data && p.attachments.data.length && p.attachments.data[0].type == 'album' ? p.medias : null,
                "link": p.permalink_url,
                "likes": p.likes,
                // "comments": p.comments?.data?.map(c => c.message)
                }
            ],
            "_id": `network_post_id-${p.id}`,
            "id": `network_post_id-${p.id}`,
            "_bots": [page.bots[0]],
            "status": "posted"
            }
            break
        case 'linkedin':
            post = {
                title: p.message,
                description: p.message,
                created_at: p.created_time,
                published_at: p.created_time,
                "url": p.link ? p.link : null,
                "enclosure": p.full_picture,
                "page": [
                    {  
                        "isManualPost": true,
                        "id": page.bots[0].id,
                        "post_number": p.id,
                        "posted_date": p.created_time,
                        "network": page.network,
                        "status": 2,
                        // "video": p.media_type == 'VIDEO' ? p.media_url : null,
                        // "link": p.permalink_url,
                        "likes": p.like_count,
                        // "comments": p.comment_count,
                        "carousel": p.carrousel && p.carrousel && p.carrousel.length ? p.carrousel : null,
                    }
                ],
                "_id": `network_post_id-${p.id}`,
                "id": `network_post_id-${p.id}`,
                "_bots": [page.bots[0]],
                "status": "posted"
            } 
            if(p.content && p.content.contentEntities && p.content.contentEntities.length){
            if(p.content.contentEntities[0].entity.includes("urn:li:article:")) {
                post.url = p.content.contentEntities[0].entityLocation 
                post.enclosure = p.content.contentEntities[0].thumbnails && p.content.contentEntities[0].thumbnails.length && p.content.contentEntities[0].thumbnails[0] && p.content.contentEntities[0].thumbnails[0].resolvedUrl
            }
            else if(p.content.contentEntities[0].entity.includes("urn:li:digitalmediaAsset:")) {
                post.enclosure = p.content.contentEntities[0].thumbnails && p.content.contentEntities[0].thumbnails.length && p.content.contentEntities[0].thumbnails[0] && p.content.contentEntities[0].thumbnails[0].resolvedUrl
                post.page[0].enclosure =  p.content.contentEntities[0].thumbnails && p.content.contentEntities[0].thumbnails.length && p.content.contentEntities[0].thumbnails[0] && p.content.contentEntities[0].thumbnails[0].resolvedUrl
            }
            }
            if(p.video) {
                post.page[0].video = p.video
                post.page[0].enclosure = p.attachment_url
                if(p.video.downloadUrl) {
                    post.page[0].video = p.video.downloadUrl
                    post.page[0].enclosure = p.video.thumbnail 
                }
            }
            if(p.document_title && p.document){
                post.page[0].document_title = p.document_title
                post.page[0].enclosure = p.document.downloadUrl
            }
            break
    }

    return post

}

export function patchDraft(draft) {
    try {
        console.log('patchDraft', draft)
        foreachSaveAllFormData(draft.saveAllFormData, (formData,type) => {

            //PATCH 25/06/2025 => nouvelle structure | formDataNetwork.instagram.storification
            if (formData.formDataNetwork && formData.formDataNetwork.instagram && !formData.formDataNetwork.instagram.storification) {
                const storificationDefault = {
                    active: false,
                    shareInFacebook: false,
                    planifiedDate: {
                        date: false,
                        hours: false,
                        timestamp: false
                    },
                }

                if ('shareInStory' in formData.formDataNetwork.instagram) {
                    storificationDefault.active = formData.formDataNetwork.instagram.shareInStory
                }

                if ('shareInStoryFacebook' in formData.formDataNetwork.instagram) {
                    storificationDefault.shareInFacebook = formData.formDataNetwork.instagram.shareInStoryFacebook
                }

                formData.formDataNetwork.instagram.storification = storificationDefault
            }

            //PATCH 25/06/2025 => ajout des tags produit | formDataNetwork.instagram.products
            if (type == 'main' && formData.formDataNetwork && formData.formDataNetwork.instagram && !formData.formDataNetwork.instagram.products) {
                formData.formDataNetwork.instagram.products = []
            }

            //PATCH 07/08/2025 =>> ajout la possibilité de spliter le text sous plusieurs tweets
            if (type == 'main' && formData.formDataNetwork && formData.formDataNetwork.twitter && !formData.formDataNetwork.twitter.tweetSplitting) {
                formData.formDataNetwork.instagram.tweetSplitting = {
                    active: false,
                }
            }
        })

        return draft;
    } catch (error) {
       console.error('Erreur lors du patchDraft:', error, draft); 
    }
    
}

async function downloadFile(url, fileName) {
    try {
        // Télécharger le fichier depuis l'URL
        const response = await fetch(url,{
            cache: 'no-store',
            mode: 'cors',
            method: 'GET',
        });
        const blob = await response.blob();

        // Créer un objet File (simule l'input file)
        const file = new File([blob], fileName || 'downloaded-file', {
            type: blob.type,
        });
        return file;
    } catch (error) {
        console.error('Erreur lors du téléchargement du fichier:', error);
    }
}
